export function renderTextWithLinks(text: string, openInNewTab = false) {
  const regex = /((https?|ftp):\/\/[^\s/$.?#].[^\s]*)/gi;

  if (openInNewTab) {
    return text.replace(regex, '<a href="$1" target="_blank">$1</a>');
  }

  return text.replace(regex, '<a href="$1">$1</a>');
}
